import React, { Component } from 'react';
import './Tooltip.css';

class Tooltip extends Component {
    state = {
        side: 'left'
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.side && nextProps.side !== this.state.side) {
            this.setState({side: nextProps.side})
        }
    }

    rotateTooltipHandler = () => {
        let nextSide = '';
        switch (this.state.side) {
            case 'left':
                nextSide = 'top'
                break;
            case 'top':
                nextSide = 'right';
                break;
            case 'right':
                nextSide = 'bottom';
                break;
            case 'bottom':
                default:
                nextSide = 'left';
            break;
        }
        this.setState({side: nextSide})
    }

    render () {
        const extraClass = this.state.side ? (' Tooltip-' + this.state.side) : ''
        const tooltipClass = 'Tooltip' + extraClass
        return (
            <div onClick={this.rotateTooltipHandler} className={tooltipClass}>
                {this.props.children}
                <span className="Tooltiptext">
                    {this.props.text.split('\n').map(line => (
                        <React.Fragment key={line}>
                            {line}
                            <br/>
                        </React.Fragment>
                    ))}
                </span>
            </div>
        )
    }
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/Components/UI/Tooltip/Tooltip.js